import { render, staticRenderFns } from "./VInvoicing.vue?vue&type=template&id=3babfd07&"
import script from "./VInvoicing.vue?vue&type=script&lang=js&"
export * from "./VInvoicing.vue?vue&type=script&lang=js&"
import style0 from "./VInvoicing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports